import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d650c742"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tips" }

import {} from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'jijia-insurance-tips',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, " 保单数据来源于平安保险系统，数据同步可能存在延迟，保单实际情况以平安保险系统为准！ "))
}
}

})